import { Separator } from '@/components/ui/separator'
import { useAuth } from '@/auth'

export function WelcomeSection() {
  const { user } = useAuth()
  
  const getFirstName = () => {
    const name = user?.name || user?.username || ''
    return name.split(' ')[0]
  }

  return (
    <>
      <div>
        <h1 className="text-2xl font-bold tracking-tight">
          Welcome back, {getFirstName()}
        </h1>
        <p className="text-muted-foreground mt-1">
          All the content intelligence needed for social media
        </p>
      </div>

      <Separator />
    </>
  )
} 